export type { RenderNextAnimationFrameProps } from './render-next-animation-frame';
export { default as RenderNextAnimationFrame } from './render-next-animation-frame';
